 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		13: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"8930f8152b9a068f3c88dc89c807f15737e64113","2":"c6921a4f1f678ab1c2814047ea9e84616f743023","3":"383dd1784bc48d87a1687d898663a208e0dad71e","4":"8b17105dcc74487b6d7c972531e747922ea7e760","5":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","11":"4a3ea9cd","12":"9e1ce6bf136742dc62dfd731df507696f34e2763","17":"ad7f724d","19":"component---cache-caches-gatsby-plugin-offline-app-shell-js","20":"component---src-pages-404-js","21":"component---src-pages-akademia-beomni-e-commerce-js","22":"component---src-pages-ebook-index-js","23":"component---src-pages-email-js","24":"component---src-pages-index-js","25":"component---src-pages-kariera-index-js","26":"component---src-pages-kontakt-dziekujemy-js","27":"component---src-pages-kontakt-index-js","28":"component---src-pages-o-nas-index-js","29":"component---src-pages-polityka-prywatnosci-index-js","30":"component---src-pages-tagi-index-js","31":"component---src-templates-blog-js","32":"component---src-templates-blog-post-js","33":"component---src-templates-offer-js","34":"component---src-templates-offer-page-js","35":"component---src-templates-offer-post-js","36":"component---src-templates-partner-post-js","37":"component---src-templates-partners-js","38":"component---src-templates-portfolio-cat-js","39":"component---src-templates-portfolio-js","40":"component---src-templates-portfolio-post-js","41":"component---src-templates-tagi-js","42":"d91e9ae9","43":"ff239f9d"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"5ee34ae824a5ab8cc886","2":"20fa4053077a75782c56","3":"ca63e945a9d2d35b4ba8","4":"50f23edb09996f1e1a18","5":"c15eed9dc5898aafdd3c","6":"f9d151b01f22cae8ef57","7":"f6bb27d7927f6c4af3c2","8":"a1f6e4ae410b3e637068","9":"abb8c336934547ea07e7","10":"1208b770923dda88f27f","11":"213aa979648335d5fe1e","12":"5d348d3c788df5f148bc","14":"9ecdd8cc1668ea30daed","15":"d861845a6a42a5f179f7","17":"f01fb1209916658216e8","19":"03fc4af6dc28ea1e7a3b","20":"8d39b7bb37c514d2d2e3","21":"be6d3a46a1a4be08d3ad","22":"2858fbf7271e7a7b46b0","23":"5d5c009d25a4f4ac649e","24":"c317c859a0b68f63643f","25":"7f9cfe01ebc6432b92f4","26":"01b794127ca0d3636a8d","27":"92b95c61720abdc01982","28":"4fcf003d9bbe1474be1a","29":"1c87f07b60922bf1dd2f","30":"e6a326ccd4ca819e5e24","31":"f56c8375349de642ace5","32":"bc01ae754f5224b25edd","33":"da6ec0dd027b266136d2","34":"6174d429ac8f3facf60c","35":"5688e44ee795e6dd8058","36":"612de02ba0e83ba3f3f2","37":"c011df8065e7ca8e9d37","38":"ae8ac31bf904531526b1","39":"93279f48b3af59570254","40":"3bd8edb40e638c3d5aad","41":"f130edc46f2f7cc21135","42":"5895fd3f744500f442d6","43":"254e4f59bdb6a45841fa","46":"2c4434e50ad9a11ee5b8","47":"70811a3a81304e675a0b","48":"4729bdeeb6772587cc03","49":"5030776c498bbbe6d969","50":"f15ed9a7a977cb5bdabe","51":"de585f2230abca2d5f51","52":"4498b8921f33ba9870fb","53":"e7b9645bc558d83c9da5","54":"728bd4def184bf434d6c","55":"2cc6a5df0290d571aa08","56":"342d9f6ca6f3659a9572","57":"e74f2b970ae06cafbece","58":"cad1a5b762d4005eaf20","59":"4434bcabf0daeb1d1138"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"8930f8152b9a068f3c88dc89c807f15737e64113","2":"c6921a4f1f678ab1c2814047ea9e84616f743023","3":"383dd1784bc48d87a1687d898663a208e0dad71e","4":"8b17105dcc74487b6d7c972531e747922ea7e760","5":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","11":"4a3ea9cd","12":"9e1ce6bf136742dc62dfd731df507696f34e2763","17":"ad7f724d","19":"component---cache-caches-gatsby-plugin-offline-app-shell-js","20":"component---src-pages-404-js","21":"component---src-pages-akademia-beomni-e-commerce-js","22":"component---src-pages-ebook-index-js","23":"component---src-pages-email-js","24":"component---src-pages-index-js","25":"component---src-pages-kariera-index-js","26":"component---src-pages-kontakt-dziekujemy-js","27":"component---src-pages-kontakt-index-js","28":"component---src-pages-o-nas-index-js","29":"component---src-pages-polityka-prywatnosci-index-js","30":"component---src-pages-tagi-index-js","31":"component---src-templates-blog-js","32":"component---src-templates-blog-post-js","33":"component---src-templates-offer-js","34":"component---src-templates-offer-page-js","35":"component---src-templates-offer-post-js","36":"component---src-templates-partner-post-js","37":"component---src-templates-partners-js","38":"component---src-templates-portfolio-cat-js","39":"component---src-templates-portfolio-js","40":"component---src-templates-portfolio-post-js","41":"component---src-templates-tagi-js","42":"d91e9ae9","43":"ff239f9d"}[chunkId]||chunkId) + "." + {"0":"dbfdf31a3f71b09ea62d","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
